/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import {Highlights} from "../components/Highlights";
import {PeopleGrid} from "../components/PeopleGrid";
import {Gap} from "../components/Gap";
import {Layout as PageLayout} from "../components/Layout";
import {GroupPictures} from "../components/GroupPictures";
import {Contact} from "../components/Contact";
import {TextHeader} from "../components/TextHeader";
import {TitleHeader} from "../components/TitleHeader";
import {Sponsors} from "../components/Sponsors";
const MDXLayout = function Layout({children}) {
  return React.createElement(PageLayout, {
    lang: "nl"
  }, children);
};
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(TitleHeader, {
    title: "Studenten Rechtsbureau Maastricht"
  }), "\n", React.createElement(Gap, {
    size: 50
  }), "\n", React.createElement(Highlights, {
    lang: "nl"
  }), "\n", React.createElement(Gap, {
    size: 40
  }), "\n", React.createElement(TextHeader, {
    title: "Het Doel"
  }), "\n", React.createElement(_components.p, null, "Het Studenten Rechtsbureau Maastricht geeft sinds de jaren 90 gratis juridisch advies aan studenten. Dit wordt mogelijk gemaakt door 15-20 enthousiaste universitaire rechtenstudenten die zich vrijwillig voor het Rechtsbureau inzetten naast hun studie. Het Studenten Rechtsbureau Maastricht is onderdeel van de"), "\n", React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "https://www.lsr.nl/"
  }, "Landelijke Stichting Rechtshulp")), "\n", React.createElement(_components.p, null, "We geven telefonisch advies, maar u bent ook welkom tijdens ons inloopspreekuur. Bovendien kunt u ons bereiken per mail. Wanneer mogelijk, proberen we u meteen te adviseren, of we verwijzen u wanneer nodig door naar een gespecialiseerde instantie of een advocaat."), "\n", React.createElement(_components.p, null, "Het Rechtsbureau richt zich voornamelijk op het beantwoorden van vragen over huurrecht, onderwijsrecht, arbeidsrecht en consumentenrecht. Omdat onze medewerkers breed geschoold zijn, kunt u uiteraard ook met andere soorten juridische problemen bij ons terecht. We staan geen studenten bij op het gebied van strafrecht of zaken met een groot financieel belang. Cliënten kunnen tevens rekenen op vertrouwelijkheid van hetgeen besproken wordt."), "\n", React.createElement(Gap, {
    size: 40
  }), "\n", React.createElement(TextHeader, {
    title: "Het Team"
  }), "\n", React.createElement(_components.p, null, "Het Rechtsbureau bestaat uit de onderstaande rechtenstudenten die zich vrijwillig inzetten naast hun studie om studenten te helpen met juridische problemen."), "\n", React.createElement(PeopleGrid, {
    lang: "nl"
  }), "\n", React.createElement(GroupPictures), "\n", React.createElement(Gap, {
    size: 40
  }), "\n", React.createElement(TextHeader, {
    title: "Contact"
  }), "\n", React.createElement(Contact, {
    lang: "nl"
  }), "\n", React.createElement(Gap, {
    size: 40
  }), "\n", React.createElement(TextHeader, {
    title: "Sponsoren"
  }), "\n", React.createElement(Sponsors, {
    lang: "nl"
  }));
}
function MDXContent(props = {}) {
  return React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props));
}
export default MDXContent;
